import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Option } from '../../../interfaces/option.interface';
import { TranslateModule } from '@ngx-translate/core';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgIf, NgFor } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatFormFieldModule, NgIf, MatSelectModule, FormsModule, ReactiveFormsModule, NgFor, MatOptionModule, TranslateModule]
})
export class SelectComponent {
    @Input() control: UntypedFormControl;
    @Input() id = '';
    @Input() placeholder = 'LABELS.SELECT';
    @Input() options: Option[];
    @Input() required: boolean;
    @Input() icon: string;

    @Output() selected = new EventEmitter<any>();
}

